import React, { useState } from "react";
import {
  Card,
  CardBody,
  Table,
  Button,
  Offcanvas,
  OffcanvasHeader,
} from "reactstrap";
import numberToWords from "../../../../../Components/Common/numberToWords";
import InvoiceBillModal from "./InvoiceBillModal";
import { PrintBill } from "../../../BillPrint/page/PrintBill";

const InvoiceSummaryMobile = ({
  isOpen,
  toggle,
  orgInfo,
  user,
  selectedTable,
  orderId,
  items,
  calculateTotals,
  paymentStatus,
  selected,
  handleCheckout,
  handleSelect,
  promoSuccess,
  discountAmount,
  discountPercent,
  selectedCustomer,
  selectedPayment,
  rawOrder,
}) => {
  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="bottom"
      scrollable={true}
      style={{
        height: "95vh",
        transition: "transform 0.3s ease",
        borderTopLeftRadius: "1rem",
        borderTopRightRadius: "1rem",
        zIndex: 1050,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="d-flex flex-column h-100">
        <OffcanvasHeader toggle={toggle} className="p-3 ">
          <h6>Estimate Invoice</h6>
        </OffcanvasHeader>
        <div style={{ flex: 1, overflowY: "auto" }} className="p-2">
          <Card className="border-1 rounded-3">
            <CardBody
              className="d-flex flex-column p-3"
              style={{ fontFamily: "monospace", fontSize: "14px" }}
            >
              {/* Header */}
              <div className="text-center mb-2">
                <h5 className="fw-bold text-uppercase mb-0">
                  {orgInfo?.name || "Company Name"}
                </h5>
                <div className="text-uppercase">{orgInfo?.address1 || ""}</div>
                <div>{orgInfo?.tel || "000-0000000"}</div>
                <div className="fw-bold mt-1 text-uppercase">
                  Provisional Invoice
                </div>
              </div>

              {/* Info Rows */}
              <div className="d-flex justify-content-between small mb-1">
                <div>
                  <strong>PAN No.:</strong> {orgInfo?.panNumber || "...."}
                </div>
                <div>
                  <strong>Copy of:</strong> Original
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-1">
                <div>
                  <strong>Customer:</strong>{" "}
                  {selectedCustomer
                    ? `${selectedCustomer.firstName} ${selectedCustomer.lastName}`
                    : "...."}
                </div>
                <div>
                  <strong>PAN:</strong> {"..."}
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-1">
                <div>
                  <strong>Phone No.:</strong>{" "}
                  {selectedCustomer?.phoneNo || "...."}
                </div>
                <div>
                  <strong>Cashier:</strong> {user?.name || "..."}
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-1">
                <div>
                  <strong>Address:</strong>{" "}
                  {selectedCustomer?.address || "...."}
                </div>
                <div>
                  <strong>INV No:</strong> {orderId || "..."}
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-2">
                <div>
                  <strong>Date (B.S.):</strong> 2082/03/26
                </div>
                <div>
                  <strong>Date (A.D.):</strong>{" "}
                  {new Date().toLocaleDateString("en-GB")}
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-2">
                <div>
                  <strong>Table:</strong> {selectedTable?.tableName || "T-1"}
                </div>
                <div>
                  <strong>Time:</strong>{" "}
                  {new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
              </div>

              {/* Table */}
              <Table size="sm" responsive className="table-bordered small mb-0">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Item</th>
                    <th className="text-center">Qty</th>
                    <th className="text-center">Rate</th>
                    <th className="text-end">Amnt</th>
                  </tr>
                </thead>
                <tbody>
                  {items?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.productName}</td>
                      {item?.complimentaryQuantity > 0 ? (
                        <td className="text-center ">
                          {item?.complimentaryQuantity}
                        </td>
                      ) : (
                        <td className="text-center ">{item?.quantity}</td>
                      )}{" "}
                      <td className="text-center">{item?.productPrice.toFixed(2)}</td>
                      <td className="text-end">
                        {(item?.productPrice * item?.quantity).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Totals */}
              <div className="border-top pt-2 small">
                <div className="d-flex justify-content-between">
                  <div>Total Qty:</div>
                  <div>
                    {items?.reduce(
                      (total, item) =>
                        total +
                        item?.quantity +
                        (item?.complimentaryQuantity || 0),
                      0
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <div>Sub Total:</div>
                  <div>Rs. {calculateTotals?.subTotal?.toFixed(2)}</div>
                </div>
                {/* <div className="d-flex justify-content-between">
                  <div>Discount Amount:</div>
                  <div>-Rs {calculateTotals.discount.toFixed(2)}</div>
                </div> */}

                {(promoSuccess || discountAmount) && (
                  <div className="d-flex justify-content-between">
                    <div>Discount Amount:</div>
                    <div>Rs {calculateTotals.discount.toFixed(2)}</div>
                  </div>
                )}
                <div className="d-flex justify-content-between fw-bold">
                  <div>Net Amount:</div>
                  <div>Rs. {calculateTotals.total.toFixed(2)}</div>
                </div>
                <div className="mt-2">
                  <div>
                    <strong>In Words:</strong>{" "}
                    {numberToWords(calculateTotals.total)} Rupees
                  </div>
                </div>
                <div className="mt-2">
                  <div>
                    Payment Mode: {selectedPayment?.name} (Rs{" "}
                    {calculateTotals.total.toFixed(2)})
                  </div>
                </div>
                <div className="mt-2">
                  <div>Billed by: {user?.name || "Staff"}</div>
                </div>
              </div>

              {/* Footer Info */}
              <div className="small mt-2">
                <div className="text-center mt-2">**Thank You**</div>
                <div className="text-center text-muted small">
                  Powered by Restro Order
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="p-2 border-1 shadow-sm border-top  position-sticky d-flex justify-content-center gap-3   sticky-bottom align-items-center">
          <button
            className="btn btn btn-soft-success shadow-sm w-100 align-items-center d-flex align-content-center justify-content-center gap-2"
            onClick={() => {}}
          >
            <i class="ri-download-line"></i>
            Download
          </button>
          <div className="d-flex bg-success bg-opacity-25 w-100 justify-content-center align-content-center align-items-center gap-2">
            <PrintBill
              currentOrder={items}
              orgInfo={orgInfo}
              user={user}
              orderId={orderId}
              calculateTotals={calculateTotals}
              responseData={rawOrder}
              isestimateprint={true}
              selectedCustomer={selectedCustomer}
            />
            <strong className="fs-6 text-success">Print</strong>
          </div>
          {/* <button
            className="btn btn-sm btn-soft-success shadow-sm w-100 align-items-center d-flex align-content-center justify-content-center gap-2"
            onClick={() => {}}
          >
            <i class="ri-printer-line"></i>
            Print Bill
          </button> */}
        </div>
      </div>
    </Offcanvas>
  );
};

export default InvoiceSummaryMobile;
